import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Link } from "gatsby"
import Card from '@material-ui/core/Card';
// import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  card: {
    minWidth: 275,
    minHeight: 97,
    margin: '8px'
  },
  cardContent: {
    padding: `1em 1.5em !important`,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  subTitle: {
    fontSize: '16px',
    marginTop: '0.5em',
  },
  tag: {
    fontSize: '16px',
    color: '#9468b9',
    marginTop: '0.5em',
  },
}));

export default function PostCard(props) {

  const { blog } = props;
  const classes = useStyles()
  // const bull = <span className={classes.bullet}>•</span>;
  // console.log('blog', blog);

  return (

    <Link to={blog.fields.slug}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          {/* <CardMedia
            component="img"
            className={classes.media}
            height="140"
            image={blog.frontmatter.image}
          /> */}
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {blog.frontmatter.date}
          </Typography>
          <Typography variant="h5" component="h2">
            {blog.frontmatter.title}
          </Typography>
          <Typography className={classes.subTitle} color="textSecondary">
            {blog.frontmatter.subTitle}
          </Typography>
          <div className={classes.tag}>
            {blog.frontmatter.tags && blog.frontmatter.tags.join(', ')}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}

PostCard.propTypes = {
  blog: PropTypes.object.isRequired,
};